module.exports = __webpack_public_path__ + "img/img685.2fd7f618.png";